import React from "react";
import {FormattedMessage} from "react-intl";

class Contact extends React.Component {
    render() {
        const { data, relation } = this.props;
        return (
            <div className='col-md-4'>
                <div className='card useful-info'>
                    <div className='card-body text-center'>
                        <FormattedMessage id={`app.dashboard.contact.${relation}`}>{(txt) => (<label>{txt}</label>)}</FormattedMessage>
                        <div>
                            <div className='useful-info__name'>{ data.name } { data.surname }</div>
                            <a href={`mailto:${data.email}`}>{ data.email }</a>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
}

export default Contact;
